import React from 'react'

import CommonIntegrations from './common'

import ExternalWebsiteForm from './ExternalWebsiteForm'
import SsrForm from './SsrForm'

import { useProject } from 'hooks'

const IntegrationsForm = () => {
  const { type } = useProject()

  if (type === 'external-website') {
    return (
      <div className='IntegrationsFormWrapper'>
        <ExternalWebsiteForm />
      </div>
    )
  }

  if (type === 'ssr') {
    return (
      <div className='IntegrationsFormWrapper'>
        <SsrForm />
      </div>
    )
  }

  return (
    <div className='IntegrationsFormWrapper'>
      <CommonIntegrations />
    </div>
  )
}

export default IntegrationsForm
